'use client'

import * as React from 'react'
import type { ButtonFunctionType, CopyConfig, CreditsShelfSemanticName, CreditsProductCardData } from './types.js'

/**
 * CreditsShelf Context 值类型
 */
export interface CreditsShelfContextValue {
  /** 主题 */
  theme?: 'light' | 'dark'
  /** 文案配置 */
  copy?: CopyConfig
  /** 是否展示标签 */
  showTags?: boolean
  /** 是否展示原价 */
  showOriginalPrice?: boolean
  /** 语义化类名 */
  classNames?: Partial<Record<CreditsShelfSemanticName, string>>
  /** 次要按钮文案 */
  secondaryButtonText?: string
  /** 次要按钮功能 */
  secondaryButtonFun?: ButtonFunctionType
  /** 主要按钮文案 */
  primaryButtonText?: string
  /** 主要按钮功能 */
  primaryButtonFun?: ButtonFunctionType
  /** 了解更多回调 */
  onLearnMore?: (product: CreditsProductCardData) => void
  /** 立即购买回调 */
  onShopNow?: (product: CreditsProductCardData) => void
  /** 加入购物车回调 */
  onAddToCart?: (product: CreditsProductCardData) => void
  /** 产品图片点击回调 */
  onProductImageClick?: (product: CreditsProductCardData) => void
}

const CreditsShelfContext = React.createContext<CreditsShelfContextValue | null>(null)

/**
 * 获取 CreditsShelf Context
 * @returns Context 值，如果在 Root 外使用则返回 null
 */
export function useCreditsShelfContext() {
  return React.useContext(CreditsShelfContext)
}

export { CreditsShelfContext }
